import builder from '../builder';
import Megaphone from '../../streamline-icons/bold/megaphone.svg';

export default builder('MegaphoneBold', Megaphone);
